<template>
	<view class="dialog-overlay" :class="{ active: visible }" @click.self="onMaskClick">
		<view class="dialog-box" :style="{ maxWidth: width }">
			<view class="dialog-header">
				<text class="dialog-title">{{ title }}</text>
				<view v-if="closable" class="dialog-close" @click="onClose">
					<text>✕</text>
				</view>
			</view>
			<view class="dialog-body">
				<slot></slot>
			</view>
			<view v-if="footer" class="dialog-footer">
				<slot name="footer"></slot>
			</view>
		</view>
	</view>
</template>

<script setup>
	const props = defineProps({
		visible: { type: Boolean, default: false },
		title: { type: String, default: '提示' },
		width: { type: String, default: '420px' },
		closable: { type: Boolean, default: true },
		maskClosable: { type: Boolean, default: true },
		footer: { type: Boolean, default: true }
	})

	const emit = defineEmits(['update:visible', 'close'])

	function onClose() {
		emit('update:visible', false)
		emit('close')
	}

	function onMaskClick() {
		if (props.maskClosable) onClose()
	}
</script>

<style scoped>
	.dialog-overlay {
		display: none;
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.5);
		backdrop-filter: blur(4px);
		-webkit-backdrop-filter: blur(4px);
		z-index: 900;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	.dialog-overlay.active {
		display: flex;
	}

	.dialog-box {
		position: relative;
		width: 90vw;
		background: var(--bg-modal);
		border: 1px solid var(--glass-border);
		border-radius: 16px;
		box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: dialogIn 0.25s ease;
		transition: background 0.4s, border-color 0.4s;
	}

	@keyframes dialogIn {
		from {
			opacity: 0;
			transform: scale(0.92) translateY(12px);
		}
		to {
			opacity: 1;
			transform: scale(1) translateY(0);
		}
	}

	.dialog-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 18px 52px 14px 22px;
		border-bottom: 1px solid var(--divider);
	}

	.dialog-title {
		font-size: 17px;
		font-weight: 700;
		color: var(--text-primary);
	}

	.dialog-close {
		position: absolute;
		top: 12px;
		right: 12px;
		width: 36px;
		height: 36px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--text-muted);
		font-size: 18px;
		cursor: pointer;
		transition: background 0.2s, color 0.2s;
	}

	.dialog-close:hover {
		background: var(--glass-bg);
		color: var(--text-primary);
	}

	.dialog-body {
		padding: 24px 22px;
		overflow-y: auto;
		color: var(--text-primary);
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 12px;
		padding: 14px 22px 18px;
		border-top: 1px solid var(--divider);
	}

	/* ===== 移动端 ===== */
	@media (max-width: 768px) {
		.dialog-overlay {
			padding: 16px;
		}

		.dialog-box {
			width: 92vw;
			border-radius: 14px;
		}

		.dialog-header {
			padding: 14px 48px 12px 18px;
		}

		.dialog-title {
			font-size: 15px;
		}

		.dialog-close {
			top: 10px;
			right: 10px;
			width: 32px;
			height: 32px;
			font-size: 16px;
		}

		.dialog-body {
			padding: 18px;
		}

		.dialog-footer {
			flex-direction: column-reverse;
			gap: 10px;
			padding: 12px 18px 16px;
		}
	}
</style>
